import "shared/styles/Sidebar.css";
import React, {useState} from "react";
import {User} from "../types";
import UserComponent from "./UserComponent";
import {adminService} from "../services/adminService";
import {DataLoadingStatus} from "shared/types/common";
import {useNavigate} from "react-router-dom";
import {useAuth} from "features/auth";

const UserList = ({users, setUsers, activeUser, setActiveUser, url_user_id}: {users: User[], setUsers: React.Dispatch<React.SetStateAction<User[]>>, activeUser: User|undefined, setActiveUser:  React.Dispatch<React.SetStateAction<User | undefined>>, url_user_id?: string}) => {
    const { myUserId } = useAuth();
    const [status, setStatus] = useState<DataLoadingStatus>(DataLoadingStatus.NotLoaded);

    const navigate = useNavigate();


    if (status === DataLoadingStatus.NotLoaded) {
        setStatus(DataLoadingStatus.Loading);
        adminService.getUsers().then(resp => {
            if (resp.errorCode === undefined) {
                setUsers(resp.users);
                setStatus(DataLoadingStatus.Loaded);
            } else {
                setStatus(DataLoadingStatus.Error);
            }
        });
    }

    if (status === DataLoadingStatus.Loaded && activeUser) {
        for (let i = 0; i < users.length; i++) {
            if (activeUser.user_id === users[i].user_id && activeUser.role !== users[i].role) {
                const users_copy = [...users];
                users_copy[i].role = activeUser.role;
                setUsers(users_copy);
                break;
            }
        }
    }

    if (status === DataLoadingStatus.Loaded && activeUser?.user_id?.toString() !== url_user_id) {
        if (url_user_id) {
            let changed = false;
            for (let i = 0; i < users.length; i++) {
                if (url_user_id === users[i].user_id.toString()) {
                    setActiveUser(users[i]);
                    changed = true;
                    break;
                }
            }
            if (!changed) {
                navigate('/users');
            }
        } else {
            setActiveUser(undefined);
        }
    }
    
    const addNewUser = () => {
        const loginInput = prompt("Enter users login:");
        if (loginInput !== null && loginInput.length > 0) {
            const passwordInput = prompt("Enter users password:");
            if (passwordInput !== null && passwordInput.length > 0) {
                if (users.every(user => user.login !== loginInput.trim())){
                    setStatus(DataLoadingStatus.Loading);
                    adminService.createUser(loginInput.trim(), passwordInput.trim()).then(resp => {
                        if (resp.errorCode !== undefined) {
                            alert(`Error: ${resp.errorCode}`);
                            setStatus(DataLoadingStatus.Error);
                        } else {
                            alert(resp.message);
                            if (resp.success) setUsers(resp.users!);
                            setStatus(DataLoadingStatus.Loaded);
                        }
                    });
                } else {
                    alert("Such user already exists!");
                }
            } else {
                alert("Please, enter non-empty password!");
            }
        } else {
            alert("Please, enter non-empty login!");
        }
    }
    
    return (
        <div className="category-list">
            <p className="info-text-mini">{
                status === DataLoadingStatus.Error? "An error occured..." : 
                status !== DataLoadingStatus.Loaded? "Loading users..." :
                    users.length === 0? "There is no users" : ""
            }</p>
            <div className="scrollable users-container-wrapper">
                <div id="users-container">{
                    users.map(user =>
                        <UserComponent
                            key={user.user_id}
                            user={user}
                            isActive={user.user_id === activeUser?.user_id}
                            isMe={user.user_id === myUserId}
                            setActiveUser={setActiveUser}/>
                    )}
                </div>
            </div>
            <div>
                <button className="button green-button" disabled={status !== DataLoadingStatus.Loaded} onClick={addNewUser}>Add new</button>
            </div>
        </div>
    );
};

// export default memo(UserList);
export default UserList;